import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { HubSettingsEntryButtonAppearance } from './HubSettingsEntryButton.ts';

export const HubSettingsEntryButton: LoadableType<{
	appearance?: HubSettingsEntryButtonAppearance;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubSettingsEntryButton" */ '../src/hub-settings/HubSettingsEntryButton.tsx'
			)
		).HubSettingsEntryButton,
});

// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { HubSettingsEntryButtonAppearance } from '../src/hub-settings/HubSettingsEntryButton.tsx';
